import React, { useState } from "react";
import { ChevronDown, DollarSign } from "lucide-react";
import { useCurrency } from "../context/CurrencyContext";

const CurrencySwitcher = ({ compact = false }) => {
  const { currency, setCurrency, currencies } = useCurrency();
  const [open, setOpen] = useState(false);
  const cur = currencies.find(c => c.code === currency) || currencies[0];

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-2 border border-navy-700/20 rounded-md ${compact ? "px-2.5 py-1" : "px-3 py-1.5"} text-sm text-navy-700 hover:border-coral-300 transition-colors bg-white`}
      >
        <span className="font-semibold">{cur.symbol}</span>
        <span>{currency}</span>
        <ChevronDown className="w-3.5 h-3.5" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-xl border border-cream-200 py-2 min-w-[160px] z-50">
            {currencies.map((c) => (
              <button
                key={c.code}
                onClick={() => { setCurrency(c.code); setOpen(false); }}
                className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between hover:bg-cream-100 ${currency === c.code ? "text-coral-300 font-semibold" : "text-navy-700"}`}
              >
                <span><span className="w-5 inline-block">{c.symbol}</span> {c.code}</span>
                {currency === c.code && <span className="text-coral-300">•</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default CurrencySwitcher;
